import Main from './Main';
import Confirm from './Confirm';

export default {
  Main,
  Confirm,
};
